import { Component, Mixins, Watch } from "vue-property-decorator";
import OlMap from "@/components/ol-map";
import LocMapMixin from '@/lib/mixins/loc-map';
import { defaultInteractions, newWMSTileLayer } from '@/components/ol-map/helpers';
import BeanCoord from '@/lib/models/bean-coord';
import RightsAware from '@/lib/mixins/rights-aware';
import { DynPanelAware } from '@/components/dyn-panel';
import PanelAddContour from '@/modules/cavite-edit/components/panel-add-contour';
import Icon from '@/components/icon';
import { State } from 'vuex-class';
import CavCavite from '@/lib/models/cav-cavite';

const { rootConfig } = window as any;

@Component
export default class PartEmsCarto extends Mixins(RightsAware, DynPanelAware, LocMapMixin) {

  @State(s => s.caviteEdit.editedCavite) data: CavCavite;

  get olMap() {
    return this.$refs.mainMap as OlMap;
  }

  get emsLayer() {
    return newWMSTileLayer({name: "ems", ...rootConfig.MAP.EMS_LAYER});
  }

  get layers() {
    return [
      ...rootConfig.MAP.LAYERS.map(pl => newWMSTileLayer(pl)),
      this.emsLayer
    ];
  }

  created() {}

  @Watch("data.numCavite", {immediate: true})
  onDataIdChange(next) {
    if (next) { //edit
      this.emsLayer.getSource().updateParams({'num_cavite': next});
      this.emsLayer.setVisible(true);
    } else {
      this.emsLayer.setVisible(false);
    }
  }

  onClickUploadShp() {}

  onAddControur(data) {
    this.data.cus.shpTempDir = data;
  }

  renderMapBody() {
    return (
      <div style="height: 45vh; position: relative">
        <OlMap ref="mainMap"
          layers={this.layers}
          zoom={this.zoom}
          interactions={[
            ...this.mapDefaultInteractions
          ]}
          center={this.providedCenter as [number, number]}
          onMapMouseMove={({coordinate}) => this.overedCoordinates = BeanCoord.fromArray(coordinate)}
        />
        {this.renderOveredCoordinates()}
        {!this.isReadonly && (
        <div class="map-tb">
          <div class="map-tb-btn" onClick={() => this.pushPanel({
            clazz: PanelAddContour,
            props: {
              readonly: this.isReadonly,
              isCus: true
            },
            on: {
              commit: ({emitter, data}) => (this.onAddControur(data), emitter.remove())
            }
          })}>
            <Icon icon="draw-geom-file" class="icon is-medium info"/>
          </div>
        </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <div class="main-tab-inner">
        <div class="columns">
          <div class="column is-12">
            {this.renderMapBody()}
          </div>
        </div>
      </div>
    );
  }

}
// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-9dae81b8/carto.tsx" });